import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import stc from 'string-to-color';
import { getInitials, getFullName } from 'utils';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import LensIcon from '@material-ui/icons/Lens';

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: 'auto',
    height: 'calc(100vh - 130px)',
  },
  unreadDot: {
    width: 12,
    height: 12,
  },
}));

const GroupList = ({ groups, groupId }) => {
  const classes = useStyles();

  const hasUnactioned = (convo) => {
    
    const component = (
      <ListItemSecondaryAction>
        <LensIcon color="primary" className={classes.unreadDot} />
      </ListItemSecondaryAction>
    );
    if (convo.sms_unread_counts_aggregate.aggregate.count) return component;

    return null;
  };

  return (
    <Card className={classes.root}>
      <List>
        {groups.map((s) => (
          <ListItem
            divider
            button
            selected={groupId === String(s.id)}
            component={Link}
            to={`/groups/sms/${s.id}`}
            key={s.id}
          >
            <ListItemAvatar>
              <Avatar  style={{ backgroundColor: stc(s.name) }}>{getInitials(s.name)}</Avatar>
            </ListItemAvatar>
            <ListItemText primary={s.name} />
            {hasUnactioned(s)}
          </ListItem>
        ))}
      </List>
    </Card>
  );
};

export default GroupList;
